function Feature() {
  return (
    <div>
      {/* <!-- Feature Start--> */}
      <div class="feature wow fadeInUp" data-wow-delay="0.1s">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-lg-4 col-md-12">
              <div class="feature-item">
                <div class="feature-text">
                  <h3>WE BUY</h3>
                  <p>
                    We buy your unwanted goods for INSTANT CASH. You can also
                    get the option to buy them back with our “buyback” service
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-12">
              <div class="feature-item">
                {/* <div class="feature-icon">
                  <i class="flaticon-building"></i>
                </div> */}

                <div class="feature-text">
                  <h3>WE SELL</h3>
                  <p>
                    Discover a treasure trove of quality pre-owned goods at
                    fantastic prices! Our ever-changing inventory has something
                    for everyone.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-12">
              <div class="feature-item">
                {/* <div class="feature-icon"> */}
                {/* <i class="flaticon-call"></i> */}

                {/* </div> */}
                <div class="feature-text">
                  <h3>WE LOAN</h3>
                  <p>
                    Our 7-month pawnbroking service offers a simple, secure way
                    to borrow against your jewellery.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Feature End--> */}

      {/* <!-- About Start --> */}
      <div class="about wow fadeInUp" data-wow-delay="0.1s">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-5 col-md-6">
              <div class="about-img">
                <img src="img/RIGHTCASH_STORE.jpeg" alt="Image" />
              </div>
            </div>
            <div class="col-lg-7 col-md-6">
              <div class="section-header text-left">
                {/* <p>Welcome to RightCash</p> */}
                <h2>21 Years of Excellence</h2>
              </div>
              <div class="about-text">
                <p>
                  Proudly serving Chatham, Kent for over two decades, we’ve been
                  a established since 2004. We know life can throw curveballs,
                  and when you need cash in a hurry, we’re here to help. With
                  our established expertise, we offer a variety of fast,
                  reliable services tailored to get you the funds you need,
                  right when you need them.
                </p>

                <a class="btn" href="">
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- About End --> */}

      {/* <!-- Fact Start --> */}

      {/* <!-- Fact End --> */}
    </div>
  );
}
export default Feature;
